import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCookie from 'vue-cookie'
import Store from '../store/index.js'

import Login from '../views/Login.vue'
import Projects from '../views/Projects.vue'
import Dashboard from '../views/Dashboard.vue'
import Kv from '../views/Kv.vue'
import Fs from '../views/Fs.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    name: '404',
    redirect: 'Dashboard',
    meta: {
      middleware: 'auth'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      middleware: 'guest'
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      middleware: 'auth'
    }
  },
  {
    path: '/kv',
    name: 'Kv',
    component: Kv,
    meta: {
      middleware: 'auth'
    }
  },
  {
    path: '/fs',
    name: 'Fs',
    component: Fs,
    meta: {
      middleware: 'auth'
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

  let accessToken = VueCookie.get('access_token');
  var loggedInUser = Store.getters['User/get_user'];
  let loggedIn = (accessToken && loggedInUser);

  if(accessToken && !loggedInUser.username){
    Store.dispatch('User/useUser');
  }


  switch(to.meta.middleware){
    case 'auth':
      if(loggedIn){
        next()
      }else{
        router.push({name: 'Login'})
      }
      break;
    case 'guest':
      if(!loggedIn){
        next()
      }else{
        router.push({name: 'Dashboard'})
      }
      break;
  }

});

export default router
